import clsx from 'clsx';
import * as React from 'react';
import {
    ColorSlider as RACColorSlider,
    type ColorSliderProps as RACColorSliderProps,
} from 'react-aria-components';

export type {
    SliderOutputProps,
    SliderTrackProps,
} from 'react-aria-components';
export {
    SliderOutput,
    SliderTrack,
} from 'react-aria-components';

export type ColorSliderProps = RACColorSliderProps;

/**
 * A color slider allows users to adjust an individual channel of a color value.
 */
export const ColorSlider = React.forwardRef(function ColorSlider(
    props: ColorSliderProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACColorSlider
            ref={ref}
            {...props}
            className={clsx(
                'group/color-slider',
                '[&_.react-aria-SliderTrack]:rounded',
                '[&[data-orientation=horizontal]_.react-aria-SliderTrack]:h-5',
                String.raw`[&[data-orientation=horizontal]_.peer\/color-thumb]:top-1/2`,
                props.className
            )}
        />
    );
});
